export default "__VITE_ASSET__DBal_xO8__"